/** Server-assigned handles; clients and social providers cannot claim an unchecked username. */
export const AUTH_USER_FIELDS = {
  username: { input: false, required: false, type: "string", unique: true },
} as const;
